import { gsap } from 'gsap';
import { isMobile } from './isMobile';
import { SnapperInstance } from './snapper';

//let tlSurvival = gsap.timeline();
//tlSurvival.to('.slider-wrap.active', 0.3, {opacity: 0});
//tlSurvival.to('.survival-slider', 0.3, {opacity: 1}, '+=0.3');
//tlSurvival.from('.survival-slider .hero-third-scene__grid-item > a', 0.8, {
//    opacity: 0,
//    stagger: {
//        each: 0.3,
//        ease: 'power1.out',
//    }
//}, '+=0.3');
//tlSurvival.pause();
let buttons = $('.hero-second-scene__circle-graphics .link');
var previousTimeline;
var previousTarget;
var currentIndex = 0;
export function CircleScene() {
    buttons.on('click', (event) => {
        var index = $(event.target).closest('.link').index();
        setActive(index, true);
    });

    setActive(0, false);
    var grid = document.querySelector('.hero-third-scene__grid');
    if (isMobile()) {
        SnapperInstance.attachLocker(document.querySelector('.hero-third-scene__grid'));
    }
}

function setActive(index, animate) {
    if (index !== currentIndex) {
        $(buttons[currentIndex]).removeClass('active');
        $(buttons[index]).addClass('active');
        currentIndex = index;
    }
    if (previousTimeline) {
        previousTimeline.progress(1);
        previousTimeline.pause();
    }
    document.querySelector('.slider-wrap.active').classList.remove('active');
    var target = $('.slider-wrap:eq(' + index + ')');
    target.addClass('active');
    var backgrounds = document.querySelectorAll('.solution-backgrounds');
    var summaries = document.querySelectorAll('.solution-summary');
    for (var i = 0; i < backgrounds.length; i++) {
        if (i === index) {
            backgrounds[i].classList.add('active');
            summaries[i].classList.add('active');
        }
        else if (backgrounds[i].classList.contains('active')) {
            backgrounds[i].classList.remove('active');
            summaries[i].classList.remove('active');
        }
    }
    previousTimeline = gsap.timeline();
    if (previousTarget) {
        previousTimeline.to(previousTarget, .3, { autoAlpha: 0, zIndex: 1 });
    }
    var links = target.find('.hero-third-scene__grid-item > a');
    previousTimeline = gsap.timeline()
        .set(target, { autoAlpha: 1, zIndex: 2 });
    if (links.length && animate) {
        previousTimeline.fromTo(links[0], 0.8, {
            autoAlpha: 0,
        }, {
            autoAlpha: 1
        }, '+=0.3');
        if (links[1]) {
            previousTimeline.fromTo(links[1], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '-=.6');
        }

        if (links[3]) {
            previousTimeline.fromTo(links[3], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '-=.6');
        }

        if (links[2]) {
            previousTimeline.fromTo(links[2], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '-=.6');
        }
    }
    else {
        previousTimeline.set(links, { autoAlpha: 1 });
    }
    previousTarget = target;
}

//if (isMobile()) {
//    let items = document.querySelectorAll('.hero-third-scene__grid-item a');
//    items.forEach(el => {
//        el.addEventListener('click', (e) => {
//            if (!el.classList.contains('active-item')) {
//                e.preventDefault();
//                if (el.parentNode.querySelector('a.active-item')) {
//                    el.parentNode.querySelector('a.active-item').classList.remove('active-item');
//                }
//                el.classList.add('active-item');
//            }
//        });
//    });
//}